export default __webpack_public_path__ + "static/06.01-3e12f80b625dbd8c4b1087bfb54148c4.png";